import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chart1",
  "use": "icon-chart1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"chartIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-chart1\"> <title id=\"icon-chart1_chartIconTitle\">Chart</title> <polygon points=\"2 12 2 21 6 21 6 12\" /> <polygon points=\"18 7 18 21 22 21 22 7\" /> <polygon points=\"10 3 10 21 14 21 14 3\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol